
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/ticket",
      function () {
        return require("private-next-pages/buy/ticket/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/ticket"])
      });
    }
  